import { useEffect } from "react";

/**
 * Square corners for signed-in pages and the free signup flow.
 * Sets data-shape="square" on <html> so portals (drawers, toasts, tooltips)
 * inherit it too; styles.css maps every radius token to 0 under it.
 */
export function useSquareShape() {
  useEffect(() => {
    const el = document.documentElement;
    el.dataset.shape = "square";
    return () => { delete el.dataset.shape; };
  }, []);
}
